import React from "react";
import { Outlet, NavLink, useNavigate, Navigate } from "react-router-dom";
import { Package, Tags, Megaphone, ClipboardList, Settings, Users, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/admin", label: "Products", icon: Package, end: true },
  { to: "/admin/categories", label: "Categories", icon: Tags },
  { to: "/admin/announcements", label: "Announcements", icon: Megaphone },
  { to: "/admin/orders", label: "Orders", icon: ClipboardList },
  { to: "/admin/settings", label: "Settings", icon: Settings },
  { to: "/admin/users", label: "Admins", icon: Users },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  const navigate = useNavigate();

  if (!ready) return <div className="min-h-screen flex items-center justify-center text-[#A8A2A0]">Loading...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-30 bg-black border-b border-[#E60000]">
        <div className="flex items-center justify-between px-4 h-14">
          <button onClick={() => navigate("/")} className="flex items-center gap-2">
            <img src="/logo_wide.webp" alt="RED EYE" className="h-7" />
            <span className="font-heading font-bold uppercase text-[#A8A2A0] text-xs">Admin</span>
          </button>
          <div className="flex items-center gap-3">
            <button onClick={() => window.open("/", "_blank")} className="text-[#A8A2A0] hover:text-[#E60000]" title="View site" data-testid="view-site-btn"><ExternalLink size={20} /></button>
            <button onClick={() => { logout(); navigate("/admin/login"); }} className="text-[#A8A2A0] hover:text-[#E60000]" data-testid="admin-logout"><LogOut size={20} /></button>
          </div>
        </div>
        <nav className="flex gap-1 px-2 overflow-x-auto no-scrollbar border-t border-[#1c1c1c]">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={`admin-tab-${t.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-1.5 px-3 py-3 text-xs font-heading font-bold uppercase whitespace-nowrap border-b-2 transition-colors ${isActive ? "border-[#E60000] text-[#F0EDEA]" : "border-transparent text-[#A8A2A0]"}`}
            >
              <t.icon size={15} /> {t.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-4xl mx-auto p-4 pb-20">
        <Outlet />
      </main>
    </div>
  );
}
